<template>
  <v-container fluid>
    <v-snackbar v-model="copyMessage" color="success" top right :timeout="1500">
      <span><v-icon dark class="mr-2">mdi-checkbox-multiple-marked-circle</v-icon>{{ copyMessageText }}</span>
    </v-snackbar>
    <!-- メイン -->
    <v-row no-gutters class="mb-4">
      <v-col cols="12">
        <v-row justify="end">
          <v-btn class="mr-2" depressed color="grey lighten-1" :to="{ name: 'ConstructionMasterDetail', params: { id: constructionId } }">キャンセル</v-btn>
          <v-btn class="mr-4" depressed color="primary" @click.prevent="comformDialog=!comformDialog">確認</v-btn>
        </v-row>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <v-card>
          <v-row no-gutters>
            <v-col cols="12">
              <v-chip color="accent" outlined label pill>
                <strong class="mr-2">工事原価</strong><v-icon small left>mdi-currency-jpy</v-icon>{{ totalBudgetPrice }}
              </v-chip>
              <v-divider/>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <!-- 工種選択 -->
            <v-col cols="12" md="3">
              <custom-tree-view :elevation="0" :title="treeTitle" :items="treeItems"
              @onSelected="onSelected" @onUnSelected="onUnSelected" @onTemplate="onTemplate" @onCopy="onCopy" @onReflect="onReflect" @onRemove="onRemove" @onEdit="onEdit"/>
            </v-col>
            <!-- 工種表示 -->
            <v-col cols="12" md="9">
              <custom-data-table :elevation="0" :tableName="tableName" :header="headers" :items="items" :loading="loading"
                :disableStore="disableStore" @stored="storedBudget">
                <template v-slot:custom>
                  <v-chip color="accent" outlined label pill>
                    <strong class="mr-2">選択工事原価</strong><v-icon small left>mdi-currency-jpy</v-icon>{{ budgetPrice }}
                  </v-chip>
                  <v-divider/>
                </template>
                <template v-slot:action="{ item }">
                  <v-btn class="mr-2" depressed small @click.stop="updateBudget(item)" color="primary">編集</v-btn>
                  <v-btn class="mr-2" depressed small @click.stop="deleteBudget(item)" color="error">削除</v-btn>
                </template>
                <template v-slot:move="{ item }">
                  <v-icon class="mr-2" depressed @click.stop="onUp(item)" :disabled="upDisabledCheck(item)">mdi-menu-up-outline</v-icon>
                  <v-icon class="mr-2" depressed @click.stop="onDown(item)" :disabled="downDisabledCheck(item)">mdi-menu-down-outline</v-icon>
                </template>
              </custom-data-table>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <!-- 工種名称変更ダイアログ -->
    <v-row justify="center">
      <v-dialog v-model="budgetNameEditDialogDrawer" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">工種名称変更</v-card-title>
          <v-card-text>
            <v-form ref="edit_budget_name_form" v-model="nameStoreValid" @submit.prevent>
              <v-text-field v-model="tempBudgetName" label="工種名称" :rules="budgetNameRules" dense outlined required>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn depressed @click.stop="budgetNameEditDialogCancelHandler">キャンセル</v-btn>
              <v-btn depressed color="warning" @click.stop="budgetNameEditDialogHandler" :disabled="!nameStoreValid">更新</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- 新規登録ダイアログ -->
    <v-row justify="center">
      <v-dialog v-model="storeDialogDrawer" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">新規登録</v-card-title>
          <v-card-text>
            <!-- <v-select v-show="expenses.length > 0" v-model="expense" label="費目" :items="expenses" item-text="name" item-value="value" @change="expenseChange" no-data-text="データがありません" dense outlined return-object/> -->
            <v-select v-show="expenses.length > 0" v-model="category" label="カテゴリ" :items="categories" item-text="group" item-value="group" @change="categoryChange" no-data-text="データがありません" dense outlined return-object/>
            <v-select v-show="expenses.length > 0" v-model="expense" label="費目" :items="expenseList" item-text="name" item-value="value" @change="expenseChange" no-data-text="データがありません" :disabled="category == null" dense outlined return-object/>
            <v-divider class="mb-5"/>
            <v-form ref="store_expense_form" v-model="valid" @submit.prevent>
              <v-text-field v-model="expenseData.expense" label="費目名" :rules="expenseNameRules" outlined dense required>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-text-field>
              <v-text-field v-model="expenseData.standard" label="規格等" :rules="standardNameRules" outlined dense required></v-text-field>
              <v-text-field v-model="expenseData.amount" :rules="amountRules" label="数量" outlined dense required>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-text-field>
              <v-text-field v-model="expenseData.displayUnit" :rules="displayUnitRules" label="単位" outlined dense required>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-text-field>
              <v-text-field v-show="percentage_flg" v-model="expenseData.percentage" :rules="percentageRules" label="歩掛" outlined dense required>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-text-field>
              <v-text-field v-show="percentage_flg" v-model="expenseData.multipl" :rules="multiplRules" label="数量×歩掛" outlined dense required>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-text-field>
              <v-text-field v-model="expenseData.unitPrice" :rules="unitPriceRules" :label="price_updated" outlined dense required>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-text-field>
              <!-- <v-select label="消費税" :items="taxes" item-text="name" item-value="value" v-model="tax" @change="taxChange" dense outlined return-object/> -->
              <v-text-field v-model.number="expenseData.price" label="金額(税抜)" disabled outlined dense required></v-text-field>
              <v-text-field v-model.number="expenseData.taxPrice" label="金額(税込)" disabled outlined dense required></v-text-field>
              <v-row no-gutters>
                <v-col cols="11">
                  <v-autocomplete label="取引先" v-model="supplier" :items="suppliers" item-text="name" item-value="value" hide-no-data hide-selected @change="suggestChange" outlined dense return-object/>
                </v-col>
                <v-col cols="1">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon class="mt-2 ml-3" color="success" @click.stop="supplierStoreDialogHandler" v-on="on">mdi-plus-circle</v-icon>
                    </template>
                    <span>取引先登録</span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-select label="集計費目" :items="aggregates" item-text="name" item-value="value" v-model="aggregate" :rules="aggregateSelectRules" @change="aggregateChange" no-data-text="データがありません" outlined dense return-object>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-select>
              <v-text-field v-model="expenseData.remarks" label="備考" :rules="remarksRules" dense outlined required></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn depressed @click.stop="storeDialogCancelHandler">キャンセル</v-btn>
              <v-btn depressed color="success" @click.stop="storeDialogHandler" :disabled="!valid">登録</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- 編集ダイアログ -->
    <v-row justify="center">
      <v-dialog v-model="editDialogDrawer" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">編集</v-card-title>
          <v-card-text>
            <v-form ref="edit_expense_form" v-model="valid" @submit.prevent>
              <v-text-field v-model="expenseData.expense" label="費目名" :rules="expenseNameRules" outlined dense required>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-text-field>
              <v-text-field v-model="expenseData.standard" label="規格等" :rules="standardNameRules" outlined dense required></v-text-field>
              <v-text-field v-model="expenseData.amount" :rules="amountRules" label="数量" outlined dense required>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-text-field>
              <v-text-field v-model="expenseData.displayUnit" :rules="displayUnitRules" label="単位" outlined dense required>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-text-field>
              <v-text-field v-show="percentage_flg" v-model="expenseData.percentage" :rules="percentageRules" label="歩掛" outlined dense required>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-text-field>
              <v-text-field v-show="percentage_flg" v-model="expenseData.multipl" :rules="multiplRules" label="数量×歩掛" outlined dense required>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-text-field>
              <v-text-field v-model="expenseData.unitPrice" :rules="unitPriceRules" :label="price_updated" outlined dense required>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-text-field>
              <!-- <v-select label="消費税" :items="taxes" item-text="name" item-value="value" v-model="tax" @change="taxChange" dense outlined return-object/> -->
              <v-text-field v-model.number="expenseData.price" label="金額(税抜)" disabled outlined dense required></v-text-field>
              <v-text-field v-model.number="expenseData.taxPrice" label="金額(税込)" disabled outlined dense required></v-text-field>
              <v-row no-gutters>
                <v-col cols="11">
                  <v-autocomplete label="取引先" v-model="supplier" :items="suppliers" item-text="name" item-value="value" hide-no-data hide-selected @change="suggestChange" outlined dense return-object/>
                </v-col>
                <v-col cols="1">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon class="mt-2 ml-3" color="success" @click.stop="supplierStoreDialogHandler" v-on="on">mdi-plus-circle</v-icon>
                    </template>
                    <span>取引先登録</span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-select label="集計費目" :items="aggregates" item-text="name" item-value="value" v-model="aggregate" :rules="aggregateSelectRules" @change="aggregateChange" no-data-text="データがありません" outlined dense return-object>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-select>
              <v-text-field v-model="expenseData.remarks" label="備考" :rules="remarksRules" dense outlined required></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn depressed @click.stop="editDialogCancelHandler">キャンセル</v-btn>
              <v-btn depressed color="warning" @click.stop="editDialogHandler" :disabled="!valid">更新</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- 取引先登録ダイアログ -->
    <v-row justify="center">
      <v-dialog v-model="supplierStoreDialog" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">
            <span>取引先登録</span>
          </v-card-title>
          <v-card-text>
            <v-form ref="suppliers_form" v-model="supplierValid" @submit.prevent>
              <v-text-field label="取引先名" v-model="supplierName" :rules="suppliersNameRules" dense outlined>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-text-field>
              <v-text-field label="備考" v-model="supplierRemarks" :rules="remarksRules" dense outlined></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed color="grey lighten-1" @click.stop="supplierStoreDialogCancelHandler">キャンセル</v-btn>
            <v-btn color="success" @click.prevent="supplierStore" :disabled="!supplierValid" depressed>登録</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- 削除ダイアログ -->
    <v-row justify="center">
      <custom-dialog :maxWith="dialogMaxWith" :title="dialogTitle" :items="dialogItems" :drawer="deleteDialogDrawer" visibleDelete
          @deleted="deleteDialogHandler" @canceled="deleteDialogCancelHandler"/>
    </v-row>

    <!-- ツリーノードテンプレート反映ダイアログ -->
    <v-row justify="center">
      <v-dialog v-model="templateNodeDialogDrawer" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">テンプレート反映</v-card-title>
          <v-card-text>
            <v-form ref="template_node_form" v-model="templateValid" @submit.prevent>
              <v-select label="テンプレート" :items="templateItems" item-text="name" item-value="value" v-model="reflectTemplate" :rules="templateRules" :disabled="templateItems.length === 0" no-data-text="データがありません" dense outlined return-object>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-select>
            </v-form>
          </v-card-text>
          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn depressed @click.stop="templateNodeDialogDrawer = !templateNodeDialogDrawer">キャンセル</v-btn>
              <v-btn depressed color="success" @click.stop="reflectTemplateHandler" :disabled="!templateValid">反映</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- 確認ダイアログ -->
    <v-row justify="center">
      <v-dialog v-model="comformDialog" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">
            実行予算更新
          </v-card-title>
          <v-card-text>
            <h4>実行予算を更新しますか？</h4>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed color="grey lighten-1" @click.stop="comformDialog=!comformDialog">キャンセル</v-btn>
            <v-btn depressed color="warning" @click.prevent="submit">更新</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- 警告ダイアログ -->
    <v-row justify="center">
      <v-dialog v-model="alertDialog" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">
            <span><v-icon large class="mr-2" color="red">mdi-alert-octagon</v-icon>実行できません</span>
          </v-card-title>
          <v-card-text>
            上限階層(5階層)を超えています。<br/>
            アクションを実行できません。
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed color="grey lighten-1" @click.stop="alertDialog=!alertDialog">閉じる</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- 費目登録時警告ダイアログ -->
    <v-row justify="center">
      <v-dialog v-model="expenseAlertDialog" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">
            <span><v-icon large class="mr-2" color="red">mdi-alert-octagon</v-icon>実行できません</span>
          </v-card-title>
          <v-card-text>
            選択された費目は既に登録されています。
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed color="grey lighten-1" @click.stop="expenseAlertDialog=!expenseAlertDialog">閉じる</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
  import { useAppInsights } from '@/plugins/application-insights';
  import statusList from "@/helpers/const";
  import SuppliersApi from "@/api/suppliers-api";
  import BudgetApi from "@/api/budget-api"
  import Rule from "@/validation/rules";
  import CustomTreeView from '@/components/custom_ui/CustomTreeView';
  import CustomDataTable from "@/components/custom_ui/CustomDataTable";
  import CustomDialog from "@/components/custom_ui/CustomDialog";
  import CalcCommon from "@/helpers/calcCommon";

  export default {
    name: "WorkingBudgetEdit",
    components: {
      CustomTreeView,
      CustomDataTable,
      CustomDialog
    },
    data: () => ({
      // 費目データ
      expenseData: {
        id: "",
        no: 0,
        supplier: null,
        supplierName: "",
        standard: "",
        expense: "",
        amount: 0,
        displayUnit: "",
        percentage: 1,
        multipl: 0,
        unitPrice: 0,
        tax: 0,
        taxName: '',
        price: 0,
        taxPrice: 0,
        aggregate: null,
        aggregateName: '',
        achievement: 0,
        displayAchievement: "",
        remarks: "",
        priceUpdated: ""
      },
      // 金額系
      totalBudgetPrice: 0,
      budgetPrice: 0,
      // テンプレート
      templateItems: [],
      // 工種選択
      treeTitle: "工種",
      treeItems: [],
      selectedNode: null,
      copyNode: null,
      reflectTemplate: null,
      reflectTemplateNode: null,
      // 工種表示
      loading: false,
      disableStore: true,
      tableName: "選択項目",
      headers: [
          { text: "No.", value: "no" },
          { text: "費目", value: "expense" },
          { text: "規格等", value: "standard" },
          { text: "数量", value: "amount", align: 'end' },
          { text: "単位", value: "displayUnit" },
          // { text: "歩掛", value: "percentage" },
          { text: "数量×歩掛", value: "multipl", align: 'end' },
          { text: "単価", value: "unitPrice", align: 'end' },
          // { text: "消費税", value: "taxName" },
          { text: "金額(税抜)", value: "price", align: 'end' },
          // { text: "金額(税込)", value: "taxPrice" },
          { text: "取引先", value: "supplierName" },
          { text: "集計費目", value: "aggregateName" },
          { text: "アクション", value: "action" },
          { text: "", value: "move", width: "20px" },
      ],
      items: [],
      pagination: {
          page: 1,
          pageCount: 0,
          itemsPerPage: 10,
      },

      // ツリーノードテンプレート反映ダイアログ
      templateNodeDialogDrawer: false,
      // 工種名称変更ダイアログ
      budgetNameEditDialogDrawer: false,
      tempBudgetName: "",
      // 新規登録ダイアログ
      storeDialogDrawer: false,
      expenseChangeFlg: false,
      // 編集ダイアログ
      editDialogDrawer: false,
      // 取引先登録ダイアログ
      supplierStoreDialog: false,
      // 削除ダイアログ
      deleteDialogDrawer: false,
      dialogMaxWith: 500,
      dialogTitle: "削除しますか？",
      dialogItems: [],
      // 確認ダイアログ
      comformDialog: false,
      // 警告ダイアログ
      alertDialog: false,
      // 費目登録時警告ダイアログ
      expenseAlertDialog: false,

      suppliers: [],
      supplier: null,
      supplierName: "",
      supplierRemarks: "",
      expenses: [],
      expenseList: [],
      expense: null,
      categories: [],
      category: null,
      taxes: [],
      tax: null,
      aggregates: [],
      aggregate: null,
      constructionId: null,
      budgetId: null,
      revision: 0,
      percentage_flg: true,
      before_price: null,
      price_updated: "単価",

      // コピーメッセージバー
      copyMessage: false,
      copyMessageText: '',

      // バリデータ
      valid: false,
      nameStoreValid: false,
      templateValid: false,
      expenseNameRules: Rule.expenseNameRules,
      standardNameRules: Rule.standardNameRules,
      amountRules: Rule.amountRules,
      displayUnitRules: Rule.displayUnitRules,
      percentageRules: Rule.percentageRules,
      multiplRules: Rule.multiplRules,
      unitPriceRules: Rule.unitPriceRules,
      remarksRules: Rule.remarksRules,
      aggregateSelectRules: Rule.aggregateSelectRules,
      budgetNameRules: Rule.budgetNameRules,
      templateRules: Rule.templateRules,
      supplierValid: false,
      suppliersNameRules: Rule.suppliersNameRules
    }),
    created() {
      this.initialize();
    },
    watch: {
      'expenseData.unitPrice' (value) {
        if (this.before_price != null && this.before_price != value) {
          this.expenseData.priceUpdated = this.getNowYMD();
          this.price_updated = "単価 (更新日時: " + this.expenseData.priceUpdated + ")";
        }
        this.calcPrice();
        this.expenseData.unitPrice = this.stringFormat(value);
      },
      'expenseData.multipl' (value) {
        this.calcPrice();
        this.expenseData.multipl = this.stringFormat(value);
      },
      'expenseData.percentage' (value) {
        this.calcMultipl();
        this.calcPrice();
        this.expenseData.percentage = this.stringFormat(value);
      },
      'expenseData.amount' (value) {
        this.calcMultipl();
        this.calcPrice();
        this.expenseData.amount = this.stringFormat(value);
      },
      'expenseData.tax' () { this.calcPrice(); }
    },
    methods: {
      isLoading() {
        this.loading = !this.loading;
        this.$emit("loading", this.loading);
      },
      initialize() {
        this.isLoading();
        this.suppliersApi = new SuppliersApi();
        this.budgetApi = new BudgetApi();
        this.constructionId = this.$route.params.id
        this.budgetId = this.$route.params.budget
        const promise = this.budgetApi.info(this.constructionId, this.budgetId);
        promise.then(response => {
          this.revision = response.data.body.budget_info.revision;
          this.percentage_flg = response.data.body.percentage_flg.percentage_flg;
          if (!this.percentage_flg) {
            this.headers = this.headers.filter(v => v.value !== "percentage");
            this.headers = this.headers.filter(v => v.value !== "multipl");
          }
          if (response.data.body.template_list) {
            for (var template of response.data.body.template_list) {
              this.templateItems.push({
                name: template.name,
                value: template.tree_data.row
              });
            }
          }
          if (response.data.body.budget_info.tree_data) {
            this.treeItems = response.data.body.budget_info.tree_data.row;
            this.calcTotalPrice();
          }
          var category_id = null;
          var group_name = null;
          for (var expense of response.data.body.expense_list) {
            if (category_id != expense.category_id) {
              category_id = expense.category_id;
              group_name = expense.category;
              // this.expenses.push({ header: group_name });
              this.categories.push({ group: group_name });
            }
            this.expenses.push({
              name: expense.name,
              value: expense.id,
              standard: expense.standard,
              displayUnit: expense.display_unit,
              percentage: expense.percentage,
              unitPrice: expense.unit_price,
              priceUpdated: expense.price_updated,
              aggregate: expense.aggregate,
              group: group_name
            });
          }
          for (var aggregate of response.data.body.aggregate_list) {
            this.aggregates.push({
                name: aggregate.name,
                value: aggregate.id,
                flg: aggregate.aggregate_flg
            });
          }
          for (var tax of response.data.body.tax_list) {
            this.taxes.push({
                name: tax.name,
                value: tax.id,
                rate: tax.rate
            });
          }
          this.tax = this.taxes[0];
          for (var sup of response.data.body.suppliers_list) {
            this.suppliers.push({
              name: sup.name,
              value: sup.id
            });
          }
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if(error.response){
            this.$emit("error",error.response.data.message);
          }else{
            this.$emit("error","サーバーエラーが発生しました。");
          }
        }).finally(() => {
          this.isLoading();
        });
      },
      stringFormat(value) {
        var result = value.toString()
        while (result.match(/[０-９]/g)) {
          result = result.replace(/[０-９]/g, function(s) {
            return String.fromCharCode(s.charCodeAt(0) - 65248);
          });
        }
        return result;
      },
      getNowYMD(){
        var dt = new Date();
        var y = dt.getFullYear();
        var m = ("00" + (dt.getMonth()+1)).slice(-2);
        var d = ("00" + dt.getDate()).slice(-2);
        var result = y + "/" + m + "/" + d;
        return result;
      },
      // 新規追加ボタンの状態
      checkState() {
        if (this.selectedNode) {
          this.disableStore = false
        } else {
          this.disableStore = true
        }
      },
      // 工種選択
      onSelected(node) {
        this.selectedNode = node
        this.checkState();
        this.tableName = this.setTableName(node);
        this.items = node.data.items ? node.data.items : [];
        this.calcTotalPrice();
        for (var item of this.items) {
          item.unitPrice = CalcCommon.addFigure(item.unitPrice);
          item.taxPrice = CalcCommon.addFigure(item.taxPrice);
          item.price = CalcCommon.addFigure(item.price);
        }
      },
      setTableName(node) {
        var result = "";
        if (node.parent) {
          result += this.setTableName(node.parent);
          result += " > "
        }
        result += node.data.text;
        return result;
      },
      // 工種選択解除
      onUnSelected() {
        this.selectedNode = null
        this.checkState();
        this.tableName = "選択項目"
        this.items = []
        this.calcTotalPrice();
      },
      // 工種テンプレート反映
      onTemplate(node) {
        this.reflectTemplateNode = node;
        this.templateNodeDialogDrawer = true;
      },
      reflectTemplateHandler() {
        this.templateNodeDialogDrawer = false;
        var copyNode = {
          name: this.reflectTemplate.name,
          children: this.reflectTemplate.value
        }
        if (this.checkNodeHierarchy(this.reflectTemplateNode, copyNode)) {
          for (var item of this.reflectTemplate.value) {
            this.reflectTemplateNode.after(item);
          }
          this.reflectTemplateNode.remove();
          this.onUnSelected();
          this.copyMessage = true;
          this.copyMessageText = "テンプレートを反映しました";
        } else {
          this.alertDialog = true;
        }
      },
      createTemplateNode(node) {
        var children = [];
        if (node.children.length > 0) {
          for (var child of node.children) {
            var item = this.createTemplateNode(child);
            children.push(item);
          }
        }
        return {
          text: node.text,
          data: { items: Object.assign([], node.data.items)},
          children: children
        };
      },
      // 工種コピー
      onCopy(node) {
        this.copyNode = Object.assign({}, node);
        this.copyMessage = true;
        this.copyMessageText = "コピーしました";
      },
      // 工種コピー反映
      onReflect(node) {
        if (this.checkNodeHierarchy(node, this.copyNode)) {
          var item = node.after(this.createNode(this.copyNode));
          node.remove();
          if (this.selectedNode != null) {
            this.selectedNode.unselect();
          }
          item.select();
          this.copyMessage = true;
          this.copyMessageText = "コピーを反映しました";
        } else {
          this.alertDialog = true;
        }
      },
      createNode(node) {
        var children = [];
        if (node.children.length > 0) {
          for (var child of node.children) {
            var item = this.createNode(child);
            children.push(item);
          }
        }
        return {
          text: node.data.text,
          data: { items: Object.assign([], node.data.items)},
          children: children
        };
      },
      // 工種削除
      onRemove() {
        this.selectedNode = null
        this.checkState();
        this.tableName = "選択項目"
        this.items = []
        this.calcTotalPrice();
      },
      checkNodeHierarchy(targetNode, copyNode) {
        var targetNodeDepth = this.parentNodeDepth(targetNode);
        var copyNodeDepth = this.childNodeDepth(copyNode);
        return 5 >= (targetNodeDepth + copyNodeDepth);
      },
      childNodeDepth(copyNode, depth=0) {
        if (copyNode.children != null && copyNode.children.length > 0) {
          depth += 1;
          var temp = [];
          for (var child of copyNode.children) {
            temp.push(this.childNodeDepth(child, depth));
          }
          const aryMax = function (a, b) {return Math.max(a, b);}
          return temp.reduce(aryMax);
        }
        return depth;
      },
      parentNodeDepth(targetNode, depth=0) {
        if (targetNode.parent != null) {
          depth += 1;
          depth = this.parentNodeDepth(targetNode.parent, depth);
        }
        return depth;
      },
      // 工種名称変更-----------------------------------------------------------------
      onEdit() {
        this.tempBudgetName = this.selectedNode.data.text;
        if (this.$refs.edit_budget_name_form) {
          this.$refs.edit_budget_name_form.resetValidation();
        }
        this.budgetNameEditDialogDrawer = true;
      },
      budgetNameEditDialogHandler() {
        if (this.$refs.edit_budget_name_form.validate()) {
          this.selectedNode.data.text = this.tempBudgetName;
          this.budgetNameEditDialogDrawer = false;
        }
      },
      budgetNameEditDialogCancelHandler() {
        this.budgetNameEditDialogDrawer = false;
      },
      // データ移動
      onUp(item) {
        var index = this.items.indexOf(item);
        this.items.splice(index, 1);
        this.items.splice((index - 1), 0, item);
        var countNo = 1;
        for (var expenseIndex in this.items) {
          this.items[expenseIndex].no = countNo;
          countNo++;
        }
      },
      onDown(item) {
        var index = this.items.indexOf(item);
        this.items.splice(index, 1);
        this.items.splice((index + 1), 0, item);
        var countNo = 1;
        for (var expenseIndex in this.items) {
          this.items[expenseIndex].no = countNo;
          countNo++;
        }
      },
      upDisabledCheck(item) {
        var index = this.items.indexOf(item);
        return (index <= 0);
      },
      downDisabledCheck(item) {
        var index = this.items.indexOf(item);
        return (index == -1 || index == (this.items.length - 1));
      },
      categoryChange() {
        this.expenseList = this.expenses.filter(e => e.group == this.category.group);
      },
      // 費目反映
      expenseChange() {
        this.expenseData = {
          id: "",
          no: 0,
          supplier: null,
          supplierName: "",
          standard: "",
          expenceId: 0,
          expense: "",
          amount: 0,
          displayUnit: "",
          percentage: 1,
          multipl: 0,
          unitPrice: 0,
          tax: this.tax.rate,
          taxName: this.tax.name,
          price: 0,
          taxPrice: 0,
          aggregate: null,
          aggregateName: '',
          achievement: 0,
          displayAchievement: "",
          remarks: "",
          priceUpdated: ""
        };
        this.supplier = null;
        this.aggregate = null;
        this.expenseData.expenceId = this.expense.value
        this.expenseData.expense = this.expense.name
        this.expenseData.standard = this.expense.standard ? this.expense.standard : ""
        this.expenseData.displayUnit = this.expense.displayUnit
        this.expenseData.percentage = this.expense.percentage
        this.expenseData.unitPrice = this.expense.unitPrice
        this.expenseData.priceUpdated = this.expense.priceUpdated
        this.price_updated = "単価 (更新日時: " + this.expense.priceUpdated + ")";
        this.aggregate = this.aggregates.find(item => { return item.value === this.expense.aggregate });
        if (this.aggregate != null) {
          this.expenseData.aggregate = this.aggregate;
          this.expenseData.aggregateName = this.aggregate.name;
        }
        this.expenseChangeFlg = true;
      },
      // 取引先反映
      suggestChange () {
        this.expenseData.supplier = this.supplier;
        this.expenseData.supplierName = this.supplier.name;
      },
      // 集計費目反映
      aggregateChange() {
        this.expenseData.aggregate = this.aggregate;
        this.expenseData.aggregateName = this.aggregate.name;
      },
      // 消費税反映
      taxChange() {
        this.expenseData.tax = this.tax.rate
        this.expenseData.taxName = this.tax.name
      },
      // 数量×歩掛
      calcMultipl() {
        // (数量 * 歩掛) 小数点以下第２位四捨五入
        this.expenseData.multipl = CalcCommon.orgRound(this.expenseData.amount * this.expenseData.percentage, 10);
      },
      // 金額計算
      calcPrice() {
        var tmp = this.expenseData.amount;
        if (this.percentage_flg) {
          tmp = this.expenseData.multipl;
        }
        // (数量 * 歩掛) * 単価 * 消費税 小数点以下第1位切り上げ
        var cost = CalcCommon.orgCeil(tmp * CalcCommon.disFigure(this.expenseData.unitPrice), 1);
        this.expenseData.price = CalcCommon.addFigure(cost);
        this.expenseData.taxPrice = CalcCommon.addFigure(CalcCommon.orgCeil(cost + (cost * this.expenseData.tax), 1));
      },
      // 工事原価・選択工事原価 計算
      calcTotalPrice() {
        // 工事原価
        if (this.treeItems) {
          this.totalBudgetPrice = 0;
          for (var item of this.treeItems) {
            this.totalBudgetPrice += this.reducePrice(item);
          }
          this.totalBudgetPrice = CalcCommon.addFigure(this.totalBudgetPrice);
        }
        // 選択工事原価
        if (this.selectedNode) {
          this.budgetPrice = this.reducePrice(this.selectedNode);
          this.budgetPrice = CalcCommon.addFigure(this.budgetPrice);
        } else {
          this.budgetPrice = 0;
        }
      },
      reducePrice(object) {
        var price = 0;
        if (object.children.length > 0) {
          for (var child of object.children) {
            price += this.reducePrice(child);
          }
        }
        if (object.data.items.length > 0) {
          // (数量 * 歩掛) * 単価
          for (var item of object.data.items) {
            var tmp = item.amount;
            if (this.percentage_flg) {
              // (数量 * 歩掛) 小数点以下第２位四捨五入
              tmp = item.multipl;
            }
            // (数量 * 歩掛) * 単価 小数点以下第1位切り上げ
            tmp = tmp * CalcCommon.disFigure(item.unitPrice);
            tmp = CalcCommon.orgCeil(tmp, 1);
            price += tmp;
          }
        }
        return price;
      },
      // 費目登録-----------------------------------------------------------------
      storedBudget() {
        this.expenseData = {
          id: "",
          no: 0,
          supplier: null,
          supplierName: "",
          standard: "",
          expenceId: 0,
          expense: "",
          amount: 0,
          displayUnit: "",
          percentage: 1,
          multipl: 0,
          unitPrice: 0,
          tax: this.tax.rate,
          taxName: this.tax.name,
          price: 0,
          taxPrice: 0,
          aggregate: null,
          aggregateName: '',
          achievement: 0,
          displayAchievement: "",
          remarks: "",
          priceUpdated: ""
        };
        this.tax = this.taxes[0];
        this.supplier = null;
        this.category = null;
        this.expense = null;
        this.aggregate = null;
        if (this.$refs.store_expense_form) {
          this.$refs.store_expense_form.resetValidation();
        }
        this.expenseData.priceUpdated = this.getNowYMD();
        this.price_updated = "単価";
        this.storeDialogDrawer = true;
      },
      storeDialogHandler() {
        var checkflg = false;
        if (this.$refs.store_expense_form.validate()) {
          if(this.expenseChangeFlg){
            this.expenseData.expenceId = this.expense.value;
          }
          this.expenseData.id = new Date().getTime().toString() + Math.floor(Math.random() * 10).toString();
          this.expenseData.no = this.items.length > 0 ? (this.items[this.items.length - 1].no + 1) : 1
          // for(var expenseitem of this.items){
          //   if(this.expenseChangeFlg && expenseitem.expenceId == this.expenseData.expenceId){
          //     checkflg = true;
          //   }
          // }
          if (checkflg) {
            this.expenseAlertDialog = true;
            this.storedBudget();
          } else {
            this.items.push(this.expenseData)
            this.selectedNode.data.items = this.items.concat();
            this.storeDialogDrawer = false
            this.calcTotalPrice();
            for (var item of this.items) {
              item.unitPrice = CalcCommon.addFigure(item.unitPrice);
              item.taxPrice = CalcCommon.addFigure(item.taxPrice);
              item.price = CalcCommon.addFigure(item.price);
            }
          }
        }
        this.expenseChangeFlg = false;
      },
      storeDialogCancelHandler() {
        this.expenseChangeFlg = false;
        this.storeDialogDrawer = false
      },
      // 費目編集-----------------------------------------------------------------
      updateBudget(item) {
        this.expenseData = {
          id: item.id,
          no: item.no,
          supplier: item.supplier,
          supplierName: item.supplierName,
          standard: item.standard,
          expense: item.expense,
          amount: item.amount,
          displayUnit: item.displayUnit,
          percentage: item.percentage,
          multipl: item.multipl,
          unitPrice: CalcCommon.disFigure(item.unitPrice),
          tax: this.tax.rate,
          taxName: this.tax.name,
          price: CalcCommon.disFigure(item.price),
          taxPrice: CalcCommon.disFigure(item.taxPrice),
          aggregate: item.aggregate,
          aggregateName: item.aggregateName,
          achievement: item.achievement,
          displayAchievement: item.displayAchievement,
          remarks: item.remarks,
          priceUpdated: "priceUpdated" in item ? item.priceUpdated : this.getNowYMD()
        };
        this.supplier = null;
        if (this.suppliers.length > 0 && item.supplier != null) {
          this.supplier = this.suppliers.find((v)=> v.value === item.supplier.value);
        }
        this.category = null;
        this.expense = null;
        this.tax = this.taxes.find((v) => v.rate === item.tax);
        this.aggregate = null;
        if (this.aggregates.length > 0 && item.aggregate != null) {
          this.aggregate = this.aggregates.find((v)=> v.value === item.aggregate.value);
        }
        this.before_price = CalcCommon.disFigure(item.price);
        this.price_updated = "単価 (更新日時: " + this.expenseData.priceUpdated + ")";
        this.editDialogDrawer = true;
      },
      editDialogHandler() {
        const index = this.items.findIndex(item => item.no === this.expenseData.no)
        if (index !== -1) {
          this.items.splice(index,1)
          this.expenseData.unitPrice = CalcCommon.addFigure(this.expenseData.unitPrice);
          this.expenseData.taxPrice = CalcCommon.addFigure(this.expenseData.taxPrice);
          this.expenseData.price = CalcCommon.addFigure(this.expenseData.price);
          this.items.splice(index, 0, this.expenseData)
        }
        this.editDialogDrawer = false
        this.calcTotalPrice();
      },
      editDialogCancelHandler() {
        this.before_price = null;
        this.editDialogDrawer = false
      },
      // 取引先登録
      supplierStoreDialogCancelHandler() {
        this.supplierStoreDialog = false;
        this.supplierName = "";
        this.supplierRemarks = "";
      },
      supplierStoreDialogHandler() {
        this.supplierStoreDialog = true;
        if (this.$refs.suppliers_form) {
          this.$refs.suppliers_form.resetValidation();
        }
      },
      supplierStore() {
        if (this.$refs.suppliers_form.validate()) {
          this.isLoading();
          const params = {
            name: this.supplierName,
            remarks: this.supplierRemarks,
          };
          const promiseStore = this.suppliersApi.store(params);
          promiseStore.then((response) => {
              this.$emit('success', response.data.message);
          }).catch(error => {
            useAppInsights().trackException({exception: error});
            if (error.response) {
              if (error.response.data.status == statusList.status.authError) {
                this.dialogDrawer = false;
                this.$emit('logoutConform');
              } else {
                this.$emit("error",error.response.data.message);
              }
            } else {
              this.$emit("error","サーバーエラーが発生しました。");
            }
          }).finally(() => {
            this.supplierStoreDialog = false;
            const promiseList = this.suppliersApi.list();
            promiseList.then((response) => {
              this.suppliers = [];
              for (var sup of response.data.body.suppliers_list) {
                this.suppliers.push({
                  name: sup.name,
                  value: sup.id
                });
              }
            }).catch(error => {
              useAppInsights().trackException({exception: error});
              if (error.response) {
                if (error.response.data.status == statusList.status.authError) {
                  this.$emit('logoutConform');
                } else if (error.response.data.status == statusList.status.entityError) {
                  this.$emit("error",error.response.data.message);
                  this.$router.push({ name: "Dashboard" })
                } else {
                  this.$emit("error",error.response.data.message);
                }
              } else {
                this.$emit("error","サーバーエラーが発生しました。");
              }
            }).finally(() => {
              this.supplierName = "";
              this.supplierRemarks = "";
              this.isLoading();
            });
          });
        }
      },
      // 費目削除-----------------------------------------------------------------
      deleteBudget(item) {
        this.dialogItems = [
          { name: "費目", value: item.expense },
          { name: "規格等", value: item.standard },
          { name: "数量", value: item.amount },
          { name: "単位", value: item.displayUnit },
          { name: "歩掛", value: item.percentage },
          { name: "数量×歩掛", value: item.multipl },
          { name: "単価", value: item.unitPrice },
          { name: "消費税", value: item.taxName },
          { name: "金額(税抜)", value: item.price },
          { name: "金額(税込)", value: item.taxPrice },
          { name: "取引先", value: item.supplierName },
          { name: "集計費目", value: item.aggregateName },
        ]
        this.expenseData = {
          id: item.id,
          no: item.no,
          supplier: item.supplier,
          supplierName: item.supplierName,
          standard: item.standard,
          expense: item.expense,
          amount: item.amount,
          displayUnit: item.displayUnit,
          percentage: item.percentage,
          multipl: item.multipl,
          unitPrice: item.unitPrice,
          tax: item.tax,
          taxName: item.taxName,
          price: item.price,
          taxPrice: item.taxPrice,
          aggregate: item.aggregate,
          aggregateName: item.aggregateName,
          achievement: item.achievement,
          displayAchievement: item.displayAchievement,
          remarks: item.remarks,
          priceUpdated: item.priceUpdated ? item.priceUpdated : this.getNowYMD()
        }
        this.deleteDialogDrawer = true
      },
      deleteDialogHandler() {
        const index = this.items.findIndex(item => item.no === this.expenseData.no)
        this.items.splice(index,1)
        var no = 1;
        for(var item of this.items) {
          item.no = no;
          no++;
        }
        this.deleteDialogDrawer = false
        this.calcTotalPrice();
      },
      deleteDialogCancelHandler() {
        this.deleteDialogDrawer = false
      },
      // 保存
      submit() {
        this.isLoading();
        var json = this.getTreeData();
        const params = {
          tree_data: json,
          budget_price: String(CalcCommon.disFigure(this.totalBudgetPrice))
        };
        const promise = this.budgetApi.store(this.constructionId, params);
        promise.then(response => {
          this.$emit('success', response.data.message);
          this.$router.push({ name: 'ConstructionMasterDetail', params: { id: this.constructionId } });
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if(error.response){
            this.$emit("error",error.response.data.message);
          }else{
            this.$emit("error","サーバーエラーが発生しました。");
          }
        }).finally(() => {
          this.isLoading();
        });
      },
      // データ整形-----------------------------------------------------------------
      getTreeData() {
        var result = [];
        var data = this.$store.getters.tree.model;
        for(var v of data) {
          result.push(this.dataFormat(v));
        }
        return JSON.stringify({
          row: result
        });
      },
      dataFormat(object) {
        var child = []
        if (object.children.length > 0) {
          for(var v of object.children) {
            child.push(this.dataFormat(v));
          }
        }
        for (var item of object.data.items) {
          item.unitPrice = CalcCommon.disFigure(item.unitPrice);
          item.taxPrice = CalcCommon.disFigure(item.taxPrice);
          item.price = CalcCommon.disFigure(item.price);
        }
        return {
          text: object.data.text,
          data: { items: object.data.items },
          children: child
        };
      }
    }
  }
</script>

<style lang="scss">
.v-subheader {
  color: #f7863a !important;
}
</style>
